import { useState } from "react";
import { BtnApproveWidgetStyled } from "./styled";
import { ACTIVITY_RENDER_STATUS } from "utils/functions/activity";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Displays, Forms, Modals } from "components";

const BtnApproveWidget = ({ id, value, onBgLoading, onSuccess }) => {
  const [_renderModal, _setRenderModal] = useState(false);

  const _handleChange = () => {
    _setRenderModal(true);
  };
  const _handleCloseModal = () => {
    _setRenderModal(false);
  };

  const _handleSubmit = async (values) => {
    onBgLoading(true);
    let params = {
      ...values,
    };
    let res = await portalService.PUT_ACTIVITY_NOMAL_FORM_APPROVE(id, params);
    if (res && res.status === 200) {
      onBgLoading(false);
      toast.success("ดำเนินการสำเร็จ");
      onSuccess && onSuccess();
    } else {
      toast.error("เปลี่ยนไม่สำเร็จ");
    }
  };

  const renderStatus = ACTIVITY_RENDER_STATUS(value);
  return (
    <>
      <BtnApproveWidgetStyled>
        <div onClick={_handleChange}>
          <Displays.StatusLabel
            canEdit
            bg={renderStatus?.bg}
            label={renderStatus?.label}
          />
        </div>
      </BtnApproveWidgetStyled>
      <Modals.BodyEmpty
        isShowModal={_renderModal}
        onCloseModal={_handleCloseModal}
      >
        <Forms.ChangeStatusForm
          onCancel={_handleCloseModal}
          onSubmit={_handleSubmit}
        />
      </Modals.BodyEmpty>
    </>
  );
};

export default BtnApproveWidget;
